<template>
  <Container type="card-full" v-loading="loading">
    <div slot="header" class="header">
      <vxe-button
        type="primary"
        v-if="+type === 4 && +project.projectjjbgstatus === 1"
        @click="saveCGBG"
        >保存</vxe-button
      >
      <vxe-button
        type="primary"
        class="vxe-btn"
        @click="checkDialog(2)"
        v-if="+type === 4 && +project.projectjjbgstatus === 1"
        :loading="btnLoading"
        >提交</vxe-button
      >
      <vxe-button
        type="primary"
        class="vxe-btn"
        @click="checkDialog(3)"
        v-if="displayOk"
        :loading="btnLoading"
        >审核</vxe-button
      >
      <span class="status">{{ project.projectjjbgstatusdesc }}</span>
    </div>
    <div class="opinion">
      <div class="statusdesc" v-if="project.projectsubmitdesc">
        <span style="color: red">提交意见：</span>
        <span>{{ project.projectsubmitdesc }}</span>
      </div>
      <div class="statusdesc" v-if="project.projectcgcheckdesc">
        <span style="color: red">审核意见：</span>
        <span>{{ project.projectcgcheckdesc }}</span>
      </div>
    </div>
    <div class="notice-content">
      <h2 class="title-A">关于{{ project.projectname }}采购报告</h2>
      <div class="line-A"></div>
      <div class="line-A"></div>
      <div class="content">
        <div
          v-if="+type === 4 && +project.projectjjbgstatus === 1"
          ref="editorCGNR"
          style="text-align: left; width: 850px"
        ></div>
        <div v-else v-html="project.projectjjcontent"></div>
      </div>
      <el-dialog
        :close-on-click-modal="false"
        :title="status === 2 ? '提交' : '审核'"
        :visible.sync="dialogVisible"
        width="720px"
        :modal-append-to-body="false"
      >
        <div v-if="status === 3">
          <div class="view-container">
            <div class="view-box">
              <div class="view-row">
                <div class="view-field">
                  <div class="view-label">报告结果</div>
                  <div class="view-value">
                    <el-radio v-model="projectjjbgstatus" :label="3"
                      >同意</el-radio
                    >
                    <el-radio v-model="projectjjbgstatus" :label="4"
                      >不同意</el-radio
                    >
                  </div>
                </div>
              </div>
              <div class="view-row">
                <div class="view-field">
                  <div class="view-label">审核意见</div>
                  <div style="width: 380px">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 5 }"
                      :rows="5"
                      v-model.trim="checkdesc"
                      :maxlength="255"
                      show-word-limit
                    ></el-input>
                  </div>
                </div>
              </div>
              <div class="view-row">
                <div class="view-field">
                  <div class="view-label"></div>
                  <div class="view-value">
                    <vxe-button
                      type="primary"
                      class="vxe-btn"
                      @click="submit(status)"
                      :loading="btnLoading"
                      >保存</vxe-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="status === 2">
          <div class="view-container">
            <div class="view-box">
              <div class="view-row">
                <div class="view-field">
                  <div class="view-label">提交意见</div>
                  <div style="width: 380px">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 2 }"
                      v-model.trim="checkdesc"
                      :maxlength="255"
                      show-word-limit
                    ></el-input>
                  </div>
                </div>
              </div>
              <div class="view-row">
                <div class="view-field">
                  <div class="view-label"></div>
                  <div class="view-value">
                    <vxe-button
                      type="primary"
                      class="vxe-btn"
                      @click="submit(status)"
                      :loading="btnLoading"
                      >保存</vxe-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </Container>
</template>

<script>
import request from "@/utils/request";
import utils from "../../assets/js/utils";
import dayjs from "dayjs";
import E from "wangeditor";
import config from "../../assets/config";

export default {
  name: "purchaseReport",
  filters: {},
  computed: {},
  data() {
    return {
      activeName: "sc",
      projectjjbgstatus: "",
      checkdesc: "",
      project: {},
      dialogVisible: false,
      type: this.$route.params.type,
      editorCGNR: "",
      editorCGNRContent: "",
      status: 0,
      btnLoading: false,
      loading: false,
    };
  },
  created() {},
  deactivated() {
    this.$destroy();
  },
  async activated() {
    await this.getModel();
    if (
      +this.type === 4 &&
      +this.$store.getters.loginUser.comtype === 1 &&
      +this.project.projectjjbgstatus === 1
    ) {
      await this.initEditorCGNR();
    }
  },
  mounted() {
    this.getModel();
  },
  computed: {
    displayOk() {
      if (+this.project.projectjjbgstatus < 3) {
        if (+this.project.projecttype === 2) {
          return true;
        } else if (
          +this.project.projecttype === 1 &&
          +this.project.projectjjbgstatus === 2 &&
          +this.project.cositemapsynergyway === 2
        ) {
          return true;
        } else if (
          +this.type === 4 &&
          +this.$store.getters.loginUser.comtype === 2 &&
          +this.project.projectjjbgstatus === 2
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
  },
  components: {},
  methods: {
    pqcChange() {
      this.project.projectqcheckflg = 1;
    },
    pricemarkChange() {
      this.project.projectstatus = 30;
    },
    async saveCGBG() {
      if (!this.editorCGNRContent) {
        this.$message.warning("请填写完内容后再保存");
        return;
      }
      let from = {};
      from.projectid = this.project.projectid;
      from.projectjjcontent = this.editorCGNRContent;
      let data = await request({
        url: "/xmgl/project/saveCGBG",
        method: "post",
        data: from,
      });
      if (+data.issuccess === 1) {
        this.$message.success(`保存成功！`);
        return;
      } else {
        this.$message.error(`保存失败！`);
        return;
      }
    },
    async getModel() {
      this.loading = true;
      let res = await request({
        method: "get",
        url: "/xmgl/project/getProjectById",
        params: { projectid: this.$route.params.projectid },
      });
      this.project = res[0];
      this.editorCGNRContent = this.project.projectjjcontent;
      if (+this.project.projectisqcheck === 1) {
        this.activeName = "sc";
      } else {
        this.activeName = "pfxm";
      }
      this.loading = false;
    },
    async initEditorCGNR() {
      if (this.editorCGNR && this.project.projectjjcontent) {
        this.editorCGNR.txt.html(this.project.projectjjcontent);
        return;
      }
      this.editorCGNR = new E(this.$refs.editorCGNR);
      this.editorCGNR.config.onchange = (html) => {
        this.editorCGNRContent = html;
      };
      this.editorCGNR.config.uploadFileName = "file";
      this.editorCGNR.config.uploadImgServer = `${config.baseUrl}upload/upload`;
      this.editorCGNR.config.zIndex = 1;
      this.editorCGNR.create();
      if (this.project.projectjjcontent) {
        this.editorCGNR.txt.html(this.project.projectjjcontent);
      }
    },
    async submit(status) {
      if (status === 3) {
        if (+this.projectjjbgstatus < 3) {
          this.$message.warning(`请选择报告结果！`);
          return;
        }
        if (+this.projectjjbgstatus === 4 && !this.checkdesc) {
          this.$message.warning(`请输入审核意见！`);
          return;
        }
      }
      if (status === 2) {
        this.project.projectjjbgstatus = status;
      } else {
        this.project.projectjjbgstatus = this.projectjjbgstatus;
      }
      this.project.projectjjcontent = this.editorCGNRContent;
      let data = await request({
        url: "/xmgl/project/projectSubmitJjbg",
        method: "post",
        data: {
          projecttype: +this.project.projecttype,
          projectid: this.project.projectid,
          userid: this.$store.getters.loginUser.userid,
          projectjjbgstatus: this.project.projectjjbgstatus,
          projectcgcheckdesc: this.checkdesc,
          projectsubmitdesc: this.checkdesc,
          projectjjcontent: this.project.projectjjcontent,
        },
      });
      if (data.issuccess === 1) {
        let projectjjbgstatusdesc = status === 2 ? "提交" : "保存";
        this.$message.success(`${projectjjbgstatusdesc}成功！`);
        this.getModel();
        this.dialogVisible = false;
        this.status = 0;
      } else {
        this.$message.error(`${projectjjbgstatusdesc}失败！`);
      }
    },
    async checkDialog(status) {
      this.dialogVisible = true;
      this.status = status;
    },
    close() {
      this.$store.commit("close_tab", {
        routeName: this.$route.name,
        vm: this,
        newRouteName: "",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.opinion {
  font-size: 14px;
  margin-top: -8px;
  color: #606266;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC,
    Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial,
    sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
}
.title-A {
  color: #000;
  display: flex;
  flex-direction: column;
  text-align: center;
  font-weight: bold;
}
.content {
  margin-top: 20px;
}
.line-A {
  width: 100%;
  background: #000;
  height: 1px;
  margin-bottom: 1px;
}
.field {
  text-align: left;
  font-size: 16px;
}
.file {
  color: #2f74ff;
  cursor: pointer;
}
</style>
